import React, { useState, useEffect } from "react";
import "./ImageGallery.css";
import OurStory from "./OurStory";
import SubStory from "./Health/SubStory";

const images = [
  require("../Assets/gallery/Rectangle 1.png"),
  require("../Assets/gallery/Rectangle 3.png"),
  require("../Assets/gallery/Rectangle 4.JPG"),
  require("../Assets/gallery/SAN_4760.JPG"),
  require("../Assets/gallery/Rectangle 6.JPG"),
  require("../Assets/gallery/Rectangle 7.png"),
  require("../Assets/gallery/VRP_5437.JPG"),
  // require("../Assets/gallery/Rectangle 8.png"),
  //   require("../Assets/gallery/Rectangle 81.png"),
  // require("../Assets/gallery/Rectangle 9.png"),
  require("../Assets/gallery/Rectangle 10.png"),
  // require("../Assets/gallery/Rectangle 10.png"),
  // require("../Assets/gallery/Rectangle 11.png"),
  // require("../Assets/gallery/Rectangle 12.png"),
];

const ImageGallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openImage = (index) => {
    setSelectedIndex(index);
  };

  const closeImage = () => {
    setSelectedIndex(null);
  };

  const showPrev = () => {
    setSelectedIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const showNext = () => {
    setSelectedIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  // Keyboard support
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex !== null) {
        if (e.key === "ArrowLeft") showPrev();
        if (e.key === "ArrowRight") showNext();
        if (e.key === "Escape") closeImage();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedIndex]);
  const paragraphs =[
    ""
  ]

  return (
    <div className="image-gallery">
      <SubStory
      title={<>A Journey of Innovation, <br />Captured in Every Frame.</>}
      subtitle="A Visual Symphony of Our Journey from 2007 to Now."
      paragraphs={paragraphs}
      buttonText="Explore More"
      onButtonClick={"/Contact"}
    />
      <div className="gallery-grid">
  {images.map((src, i) => (
    <img
      key={i}
      src={src}
      alt={`gallery-${i}`}
      className={`gallery-img gallery-img-${i}`}
      onClick={() => openImage(i)}
    />
  ))}
</div>


      {selectedIndex !== null && (
        <div className="modal-overlay" onClick={closeImage}>
          <span className="close-btn" onClick={closeImage}>&times;</span>
          <span className="arrow left" onClick={(e) => { e.stopPropagation(); showPrev(); }}>&#10094;</span>
          <img
            src={images[selectedIndex]}
            alt={`modal-${selectedIndex}`}
            className="modal-img"
            onClick={(e) => e.stopPropagation()}
          />
          <span className="arrow right" onClick={(e) => { e.stopPropagation(); showNext(); }}>&#10095;</span>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
